var api = "https://api.qingcigame.com/web";

var index = '';
var go_page = window.location.href.split('?page=')[1];

var initialSlide = 0; //设置默认索引为0

var obj = {
    index: function() {
        function getRequest() {
            var query = window.location.search;
            if (query.indexOf("?") != -1) {
                var str = query.substring(1);
                var strs = str.split("=");
                if (strs[1] == 1) {
                    initialSlide = 1;
                } else if (strs[1] == 2) {
                    initialSlide = 2;
                } else if (strs[1] == 3) {
                    initialSlide = 3;
                } else if (strs[1] == 4) {
                    initialSlide = 4;
                } else if (strs[1] == 5) {
                    initialSlide = 5;
                } else if (strs[1] == 6) {
                    initialSlide = 6;
                }
            }
        };
        getRequest(); //二级页面导航栏跳转
        this.preloading(); // 预加载
        this.indexAjax(); // 首页接口请求
        this.jqslideTxtBox(); // 游戏咨询信息切换
        this.indexBind(); // 首页按钮
        this.newsBanner(); //游戏资讯轮播
        this.countNum(); //阿里云埋点
    },
    // 新闻列表
    newsList: function() {
        this.newsZxList(); // 新闻最新列表
        this.newsTabPage(); // 最新、综合、活动跳转
    },
    // 新闻详情
    newsDetails: function() {
        this.newsInfo();
        this.scroll();
    },
    // 游戏攻略列表
    intrList: function() {
        this.newsIntrList(); // 新闻最新列表
        this.newsTabPage(); // 最新、综合、活动跳转
    },
    // 首页按钮
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        })

        // 适龄弹窗
        $('.year-btn').click(function(event) {
            $('.year_pop').fadeIn();
        });

        // 关闭弹窗
        $('.popup').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
        });

        // 游戏攻略切换
        $(".intro li").on('click', function() {
            $(this).addClass("active").siblings().removeClass("active");
        });

        // 仙剑音画【壁纸】
        $(".wallpaper-box .item img").on('click', function() {
            var _this = $(this);
            var img_url = _this.attr('src');
            $('.wallpaper-wrap').fadeIn();
            $('.wallpaper-wrap img').attr("src", img_url);
        });

        $('.wallpaper-wrap').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
            setTimeout(() => {
                $('.wallpaper-wrap img').attr("src", '');
            }, 300)
        });

        $('.download-box').on('click', 'a', function() {
            var className = $(this).attr('class');
            var game_id = 69;
            var query = window.location.search;
            $.ajax({
                type: "get",
                url: 'https://api.qingcigame.com/get_url?game_id=' + game_id + '',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    // 百度品专 专属下载地址
                    if (query.indexOf('type=bdpz') != -1) {
                        if (className.indexOf('app-btn') !== -1) {
                            // ios
                            location.href = "https://ad.qingcigame.com/v1/ad-click?game_id=69&os=iOS&company=qc&channel=kol&tag=962499&optimizer_id=19&redirct=https://apps.apple.com/cn/app/%E6%96%B0%E4%BB%99%E5%89%91%E5%A5%87%E4%BE%A0%E4%BC%A0%E4%B9%8B%E6%8C%A5%E5%89%91%E9%97%AE%E6%83%85/id6447745041";
                        } else {
                            // 安卓
                            location.href = "https://download4.qcplay.com/apk-v2/qc-kol-1030462.apk";
                        }
                    } else {
                        if (className.indexOf('app-btn') !== -1) {
                            // ios
                            if (json.data.ios_down_url == '' || json.data.ios_down_url == null) {
                                layer.msg('ios下载暂未开放，敬请期待！', { time: 3000 });
                            } else {
                                location.href = json.data.ios_down_url
                            }
                        } else {
                            // 安卓
                            if (json.data.android_down_url == '' || json.data.android_down_url == null) {
                                layer.msg('安卓下载暂未开放，敬请期待！', { time: 3000 });
                            } else {
                                location.href = json.data.android_down_url
                            }
                        }
                    }

                }
            });
        });
    },
    newsBanner: function() {
        // index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: "https://api.qingcigame.com/web/news/info",
            type: "GET",
            data: {
                game_id: 69
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var article = json.data.article;
                    $.each(article.game_information, function(index, values) {
                        var gameInfoIndex = `<div class="swiper-slide swiper-no-swiping">
                        <a  href="${values.jump_url}">
                        <img src="${values.pc_image}">
                        <span></span>
                        </a>
                        </div>`;
                        $('.swiper-container-news .swiper-wrapper').append(gameInfoIndex);
                    });


                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    indexMedia: function() {
        var Media = document.getElementById('media-play');
        // 媒体视频播放
        $('.video-btn').on('click', function(event) {
            var _this = $(this);
            $('.thumbnail-img').fadeOut(); //视频展示图
            $('.right-video-box video').fadeIn(); //视频
            $('.video-btn-box').fadeOut(); //视频按钮
            Media.play(); //播放
        });

        // 视频预览
        $('.left-video-box li img').on('click', function() {
            var _this = $(this);
            var img_src = _this.attr('src');
            var video_src = _this.attr('data');

            $(this).parent().addClass("on").siblings().removeClass("on");
            $('.thumbnail-img').fadeIn();
            $('.right-video-box video').show();
            $('.video-btn-box').fadeIn();

            $('.thumbnail-img').find('img').attr('src', img_src); //图片填充
            $('.right-video-box').find('video').attr('src', video_src); //视频填充
        })

        Media.addEventListener('play', () => {
            $('.video-btn-box').fadeOut(); //播放开始 播放按钮隐藏
        })

        Media.addEventListener('ended', () => {
            $('.video-btn-box').fadeIn(); //播放结束 播放按钮显示
            $('.thumbnail-img').fadeIn();
        })

        // 仙剑音画切换
        $('.media-nav-box ul li').click(function() {
            if ($(this).attr("class") == "select") {
                return false
            }

            Media.pause();
            myMusic.pause();


            $(".media-nav-box .block").css("display", "block"); //防抖动弹窗
            let a = $(this).index() + 1
            console.log(a)
            switch (a) {
                case 1:
                    $(".music-box").fadeIn().siblings().fadeOut();
                    break;
                case 2:
                    $(".video-box").fadeIn().siblings().fadeOut();
                    break;
                case 3:
                    $(".wallpaper-box").fadeIn().siblings().fadeOut();
                    break;
                default:
                    return false
            }

            $('.record-player').addClass('ani-pause'); //添加暂时播放样式

            setTimeout(() => {
                $(".media-nav-box .block").css("display", "none");
            }, 500)
            $(this).addClass("select").siblings().removeClass("select");
        });

        //音乐播放按钮
        var next = document.getElementById("next");
        var prev = document.getElementById("prev");
        const myMusic = document.getElementById("myMusic");
        // 获取元素
        const progressBar = document.getElementById('progress-bar');
        const progress = document.querySelector('.progress');
        const progressHandle = document.querySelector('.progress-handle');

        var music = ["《仙剑问情》", "《杀破狼》"];
        var music_url = [
            "//download4.qcplay.com/qcgame-admin/t3L9IRtsLLoZyS06LnQ6qSyNQIgH50PzXt7xT5aF.mp3",
            "//download4.qcplay.com/qcgame-admin/Ywo1SupJovxuyF92dANET8zo9B66E1AAlKvIseWh.mp3"
        ];
        var music_content = [
            "凄婉悠长的乐声响起，一群白鹤在青天白云间展翅翱翔，烟云缥缈的仙山若隐若现……",
            "《仙剑奇侠传一电视剧》主题曲《杀破狼》：人道渺渺，仙道茫茫，鬼道乐兮！"
        ];
        var num = 0;
        $('.music-title').html(music[num]); //音乐标题
        $('.music-content').html(music_content[num]); //音乐描述

        // 点击音乐
        $('.music-box .play-box').click(function(event) {
            var _this = $(this);
            if ($('#myMusic')[0].paused) {
                $('#myMusic')[0].play();
                $('.record-player').removeClass('ani-pause'); //去除暂时播放样式
                $('.music-title').html(music[num]); //标题
                $('.music-content').html(music_content[num]); //音乐描述

                $('.record-player').addClass('music-on'); //开始播放样式
            } else {
                $('.record-player').addClass('ani-pause'); //添加暂时播放样式
                $('#myMusic')[0].pause();
            }
        });
        // 上一首
        prev.onclick = function() {
            // num = (num + 2) % music.length;
            num = (num + 3) % music.length;
            myMusic.src = music_url[num];
            $('.music-title').html(music[num]);
            $('.music-content').html(music_content[num]); //音乐描述

            myMusic.play();
            $('.record-player').removeClass('ani-pause');
            $('.record-player').hasClass('.music-on') ? '' : $('.record-player').addClass('music-on');

        };
        // 下一首
        next.onclick = function() {
            num = (num + 1) % music.length;
            myMusic.src = music_url[num];
            myMusic.play();
            $('.music-title').html(music[num]);
            $('.music-content').html(music_content[num]); //音乐描述

            $('.record-player').removeClass('ani-pause');
            $('.record-player').hasClass('.music-on') ? '' : $('.record-player').addClass('music-on');
        };

        //自动播放下一首
        myMusic.addEventListener('ended', function() {
            next.onclick();
        }, false);

        let timer = setInterval(() => {
            let str = _.convertSec2Str(myMusic.currentTime) + "/" + _.convertSec2Str(myMusic.duration);
            $('.time').html(str);
        }, 500);

        let _ = {
            repairZero(num) {
                num = num.toString()
                return num[1] ? num : ('0' + num);
            },
            makeStr() {
                let code = Array.prototype.shift.call(arguments);
                return Array.prototype.join.call(arguments, code);
            },
            convertSec2Str(total) {
                let min = _.repairZero(Math.floor(total / 60));
                let sec = _.repairZero(Math.floor(total % 60));
                return _.makeStr(':', min, sec);
            }
        };

        // 【仙剑音画】音乐进度条拖拽
        // 监听音频播放进度
        myMusic.addEventListener('timeupdate', () => {
            const progressPercent = (myMusic.currentTime / myMusic.duration) * 100;
            progress.style.width = `${progressPercent}%`;
            progressHandle.style.left = `${progressPercent}%`;
        });

        // 监听进度条点击事件
        progressBar.addEventListener('click', (event) => {
            const clickPosition = event.clientX - progressBar.getBoundingClientRect().left;
            const progressPercent = (clickPosition / progressBar.offsetWidth) * 100;
            myMusic.currentTime = (myMusic.duration / 100) * progressPercent;
        });

        // 监听进度条拖动事件
        // pc
        function pc_music_slide() {
            let isDragging = false;
            document.querySelector('.progress-handle').addEventListener('mousedown', () => {
                isDragging = true;
            });
            document.addEventListener('mousemove', (event) => {
                if (isDragging) {
                    const dragPosition = event.clientX - progressBar.getBoundingClientRect().left;
                    const progressPercent = (dragPosition / progressBar.offsetWidth) * 100;
                    myMusic.currentTime = (myMusic.duration / 100) * progressPercent;
                }
            });
            document.addEventListener('mouseup', () => {
                isDragging = false;
            });
        }

        // pad
        function pad_music_slide() {
            let isDragging = false;
            document.querySelector('.progress-handle').addEventListener('touchstart', () => {
                isDragging = true;
            });
            document.addEventListener('touchmove', (event) => {
                if (isDragging) {
                    const dragPosition = event.touches[0].clientX - progressBar.getBoundingClientRect().left;
                    const progressPercent = (dragPosition / progressBar.offsetWidth) * 100;
                    myMusic.currentTime = (myMusic.duration / 100) * progressPercent;
                }
            });
            document.addEventListener('touchend', () => {
                isDragging = false;
            });
        }

        // 【仙剑音画】壁纸进度条拖拽
        var slider = document.getElementById('drag-box');
        var block = document.getElementById('drag-bar');
        var box = document.getElementById('pics-box');
        var content = document.getElementById('pics-content');

        // pc
        function pc_wall_slide() {
            // 鼠标按下时
            block.onmousedown = function(ev) {
                console.log('down');
                var myEvent = ev || event;

                var disX = myEvent.clientX - block.offsetLeft;

                // 鼠标移动时
                document.onmousemove = function(ev) {
                    var myEvent = ev || event;
                    var left = myEvent.clientX - disX;

                    console.log(left);

                    setLeft(left);
                };
                // 鼠标抬起时
                document.onmouseup = function() {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            };
        }

        // pad
        function pad_wall_slide() {
            // 鼠标按下时
            block.ontouchstart = function(ev) {
                var myEvent = ev || event;
                var disX = myEvent.touches[0].clientX - block.offsetLeft;

                // 鼠标移动时
                document.ontouchmove = function(ev) {
                    var myEvent = ev || event;
                    var left = myEvent.touches[0].clientX - disX;
                    setLeft(left);
                };
                // 鼠标抬起时
                document.ontouchend = function() {
                    document.ontouchmove = null;
                    document.ontouchend = null;
                };
            };
        }

        // 设置滑块的left值
        function setLeft(left) {
            // 限制范围
            if (left < 0) {
                left = 0;
            } else if (left > slider.offsetWidth - block.offsetWidth) {
                left = slider.offsetWidth - block.offsetWidth;
            };

            block.style.left = left + 'px';

            // 计算滚动距离相对滚动范围的比例
            var scale = left / (slider.offsetWidth - block.offsetWidth);
            // 让content随着滚动的距离上下滑动显示内容
            content.style.left = -(content.offsetWidth - box.offsetWidth) * scale + 'px';
        }

        var ua = navigator.userAgent;
        var isAndroid = /(?:Android)/.test(ua);
        var isFireFox = /(?:Firefox)/.test(ua);
        var isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));

        if (isTablet) {
            // 是平板的话 用touch拖拽
            pad_wall_slide();
            pad_music_slide();
            // 取消no-swiper
            $('.music-box').removeClass('swiper-no-swiping');
            $('.video-box').removeClass('swiper-no-swiping');
            $('.wallpaper-box').removeClass('swiper-no-swiping');
        } else {
            // PC 用mouse拖拽
            pc_wall_slide();
            pc_music_slide();
        }
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time p").html(parseInt(e.progress * 100) + '%');
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            var _this = this;
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').addClass('index-show');
            this.indexSwiper();

            if (go_page == undefined) {}

            setTimeout(function() {
                $('.preloading').remove();
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/official/images/pc/logo_icon-fce3263abe.png',
            '/official/images/pc/code_img-b978c729e0.png',
            '/official/images/pc/apple_btn-a7ceef6745.png',
            '/official/images/pc/and_btn-c5bb77100d.png',
            '/official/images/pc/year_btn-bba9837183.png',
            '/official/images/pc/leidian_btn-e49b77a869.png',
            '/official/images/pc/top_up_btn-a657d32911.png',
            '/official/images/pc/banner_bg-9628056952.png',
            '/official/images/pc/taptap_btn-0df824269e.png',
            '/official/images/pc/qq_btn-973f80a02f.png',
            '/official/images/pc/tieba_btn-261c712341.png',
            '/official/images/pc/arrow_btn-5b5c608b36.png',
            '/official/images/pc/float_nav_on_bg-31053e56e4.png',
            '/official/images/pc/float_nav_dot-b796906636.png'
        ]);
    },
    // 首页接口请求
    indexAjax: function() {
        // var index = layer.load(2, { shade: [0.1, '#fff'] });
        var _this = this;
        $.ajax({
            url: api + "/sword/index",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var zonghe = json.data.articleList.zonghe_news; //综合
                    var activity = json.data.articleList.activity_news; //活动
                    var zuixin = json.data.articleList.zuixin; //最新
                    var mengxin = json.data.articleList.mengxin; //萌新
                    var jinjie = json.data.articleList.jinjie; //进阶

                    var video = json.data.articleList.video; //视频

                    var taptap_url = 'https://l.tapdb.net/hkT7pBAG?channel=rep-rep_mfrj9temidf';
                    var tieba_url = 'https://tieba.baidu.com/f?ie=utf-8&kw=%E6%96%B0%E4%BB%99%E5%89%91%E5%A5%87%E4%BE%A0%E4%BC%A0%E4%B9%8B%E6%8C%A5%E5%89%91%E9%97%AE%E6%83%85&fr=search';
                    var qq_url = 'https://static2.qcplay.com/qq_group_jump/index.html?game_id=69';
                    var leidian_url = 'https://lddl01.ldmnq.com/downloader/ldplayerinst9.exe?n=LDplayer9_com.xjhjwq.qc_401391_ld.exe';

                    // url地址
                    $('.taptap-btn').attr('href', taptap_url);
                    $('.qq-btn').attr('href', qq_url);
                    $('.tieba-btn').attr('href', tieba_url);
                    $('.leidian-btn').attr('href', leidian_url);

                    // 【游戏资讯】综合
                    $.each(zonghe, function(index, values) {
                        var zongheHtml = '<li>' +
                            '<a href="news-details.html?id=' + values.id + '">' +
                            '<h2>' + values.article_title + '</h2>' +
                            '<p>' + values.article_excerpt + '</p>' +
                            '<span>' + values.created_at + '</span>' +
                            '</a>' +
                            '</li>';
                        $('.zonghe').append(zongheHtml);
                    });

                    // 【游戏资讯】活动
                    $.each(activity, function(index, values) {
                        var activityHtml = '<li>' +
                            '<a href="news-details.html?id=' + values.id + '">' +
                            '<h2>' + values.article_title + '</h2>' +
                            '<p>' + values.article_excerpt + '</p>' +
                            '<span>' + values.created_at + '</span>' +
                            '</a>' +
                            '</li>';
                        $('.activity').append(activityHtml);
                    });

                    // 【游戏攻略】最新
                    $.each(zuixin, function(index, values) {
                        var zuixinHtml = `<li>
                            <a href="introduction-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.created_at}</p>
                            </a>
                        </li>`;
                        $('.new ul').append(zuixinHtml);
                    });

                    // 【游戏攻略】萌新
                    $.each(mengxin, function(index, values) {
                        var mengxinHtml = `<li>
                            <a href="introduction-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.created_at}</p>
                            </a>
                        </li>`;
                        $('.mengxin ul').append(mengxinHtml);
                    });

                    // 【游戏攻略】进阶
                    $.each(jinjie, function(index, values) {
                        var jinjieHtml = `<li>
                            <a href="introduction-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.created_at}</p>
                            </a>
                        </li>`;
                        $('.jinjie ul').append(jinjieHtml);
                    });

                    // 【仙剑音画】视频
                    if (video.length !== 0) {
                        $(".right-video-box .thumbnail-img img").attr("src", video[0].move_thumbnail);
                        $(".right-video-box video").attr("src", video[0].video_link);
                    }

                    $.each(video, function(index, values) {
                        var videoHtml = `<li>
                        <img src="${values.thumbnail}" data="${values.video_link}" >
                        </li>`;
                        $('.left-video-box ul').append(videoHtml);
                    });

                    $('.left-video-box ul').children(':eq(0)').addClass('on');
                    _this.indexMedia();

                    _this.Textlength(25, 20);
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 全屏滚动判断
    scroll: function() {
        $(window).scroll(function() {
            $(document).scrollTop() > 400 ? $('.return-top').fadeIn() : $('.return-top').fadeOut();
        });

        $('.return-top').click(function(event) {
            $(document).scrollTop(0);
        });
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheel: true,
            resistanceRatio: 0,
            initialSlide: initialSlide,
            touchMoveStopPropagation: false,
            touchStartForcePreventDefault: true,
            on: {
                init: function() {
                    swiperAnimate(this);

                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            mySwiper.slideTo(page, 1000, true);
                        });
                    };

                    function navLink() {
                        for (var i = 6; i >= 0; i--) {
                            Ani('.nav-link-0' + i + ' .link-a', i);
                        };
                    }
                    navLink();

                    var aniLink01 = Ani('.arrow-b', '1');
                    var aniLink02 = Ani('.arrow-b2', '2');
                    var aniLink04 = Ani('.arrow-b4', '3');
                    var aniLink04 = Ani('.arrow-b5', '4');
                    var aniLink04 = Ani('.arrow-b6', '5');
                },
                slideChangeTransitionEnd: function() {
                    $('.nav-link').removeClass('on')
                    $('.nav-link-0' + this.activeIndex + '').addClass('on');
                },
                transitionStart: function() {
                    swiperAnimate(this);
                },
            },
        });

        if (go_page !== undefined) {
            mySwiper.slideTo(go_page - 1, 1000, true);
        }

        var newsSwiper = new Swiper('.swiper-container-news', {
            loop: true,
            paginationClickable: true,
            pagination: {
                el: '.swiper-pagination2',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 'auto',
        });

        // 游戏特色
        var charitySwiper = new Swiper('.swiper-container-feature', {
            loop: true,
            paginationClickable: true,
            pagination: {
                el: '.swiper-pagination4',
                clickable: true,
            },
            noSwiping: true,
            autoplayDisableOnInteraction: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'coverflow',
            centeredSlides: true,
            slidesPerView: 'auto',
            loopedSlides: '5',
            observer: true,
            observerParents: true,
            speed: 500,
            coverflowEffect: {
                rotate: 3, // 旋转的角度
                stretch: 40, // 拉伸   图片间左右的间距和密集度
                depth: 25, // 深度   切换图片间上下的间距和密集度
                modifier: 15, // 修正值 该值越大前面的效果越明显
                slideShadows: false // 页面阴影效果
            },
            onInit: function(swiper) {
                swiperAnimate(this);
                swiper.stopAutoplay();
            },
        });
    },
    // 游戏咨询&游戏攻略信息切换
    jqslideTxtBox: function() {
        jQuery(".slideTxtBox").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".slideTxtBox-02").slide({ effect: "left", trigger: "click", easing: "swing" });
    },
    // 内容字体长度超过40，标题字体长度超过25
    Textlength: function(x1, x2) {
        $('.slideTxtBox .bd p').each(function() {
            if ($(this).text().length > x1) {
                var str = $(this).text();
                $(this).text(str.substr(0, x1) + '...');
            }
        });
        $('.slideTxtBox .bd h2').each(function() {
            if ($(this).text().length > x2) {
                var str = $(this).text();
                $(this).text(str.substr(0, x2) + '...');
            }
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    // 新闻最新接口
    newsZxList: function() {
        var cate_id, page, current, index;
        cate_id = obj.getQueryVariable('cate_id');
        page = obj.getQueryVariable('page');
        current = window.location.href.split("?")[0];
        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.news .tab-title .a-tab-0' + cate_id + '').addClass('on').siblings('a').removeClass('on');
        $.ajax({
            url: "https://api.qingcigame.com/web/article",
            type: "GET",
            data: {
                game_id: 69,
                cate_id: cate_id,
                page: page,
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var current_page = json.data.articleList.current_page; // 当前页数
                    var last_page = json.data.articleList.last_page; // 总共页数
                    var prev_page_url = json.data.articleList.prev_page_url; // 前一页
                    var next_page_url = json.data.articleList.next_page_url; // 后一页
                    var _data = json.data.articleList.data;
                    if (_data.length == 0) {
                        $('.main').addClass('list-null');
                    } else {
                        $('.main').removeClass('list-null');
                        // 渲染列表
                        $.each(_data, function(index, values) {
                            var dtHtml = '<li>' +
                                '<a title="' + values.article_title + '" href="news-details.html?id=' + values.id + '">' +
                                '<p class="lside">' +
                                '<span class="time">' + values.created_at + '</span>' +
                                '<span class="title" style="display: block;">' + values.article_title + '</span>' +
                                '</p>' +
                                '</a>' +
                                '</li>';
                            $('.new-list ul').append(dtHtml);
                        });
                        $('.new-list').addClass('new-list-show');
                        $('.current_page').html(current_page); // 当前页数
                        $('.last_page').html(last_page); // 总共页数
                        if (prev_page_url === null) { // 上一页
                            $('.front-link').hide(); // 没有第一页
                        } else {
                            $('.front-link').attr('href', current + '?cate_id=' + cate_id + '&page=' + prev_page_url.split("?page=")[1])
                        }
                        if (next_page_url === null) { // 下一页
                            $('.after-link').hide(); // 没有最后一页
                        } else {
                            $('.after-link').attr('href', current + '?cate_id=' + cate_id + '&page=' + next_page_url.split("?page=")[1])
                        }
                        $('.new-list').addClass('new-list-show');
                    }
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    analysisParams: function(url) {
        const params = {};
        const paramsString = url.split('?')[1];
        if (!paramsString) {
            return params;
        }
        const str = paramsString.split('&');
        for (let idx = 0; idx < str.length; idx++) {
            const values = str[idx].split('=');
            params[values[0]] = values[1];
        }
        return params;
    },
    // 游戏攻略接口
    newsIntrList: function() {
        const params = obj.analysisParams(window.location.href);
        var cate_id, page, current, index;
        cate_id = params.cate_id;
        page = params.page;

        current = window.location.href.split("?")[0];
        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.news .tab-title .a-tab-0' + cate_id + '').addClass('on').siblings('a').removeClass('on');
        var _this = $(this);
        $.ajax({
            url: "https://api.qingcigame.com/web/article",
            type: "GET",
            data: {
                game_id: 69,
                cate_id: cate_id, //最新-综合-活动
                page: page,
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var current_page = json.data.articleList.current_page; // 当前页数
                    var last_page = json.data.articleList.last_page; // 总共页数
                    var prev_page_url = json.data.articleList.prev_page_url; // 前一页
                    var next_page_url = json.data.articleList.next_page_url; // 后一页
                    var _data = json.data.articleList.data;
                    if (_data.length == 0) {
                        $('.main').addClass('list-null');
                    } else {
                        $('.main').removeClass('list-null');
                        // 渲染列表
                        $.each(_data, function(index, values) {
                            var dtHtml = '<li>' +
                                '<a title="' + values.article_title + '" href="introduction-details.html?id=' + values.id + '">' +
                                '<p class="lside">' +
                                '<span class="time">' + values.created_at + '</span>' +
                                '<span class="title" style="display: block;">' + values.article_title + '</span>' +
                                '</p>' +
                                '</a>' +
                                '</li>';
                            $('.new-list ul').append(dtHtml);
                        });
                        $('.new-list').addClass('new-list-show');
                        $('.current_page').html(current_page); // 当前页数
                        $('.last_page').html(last_page); // 总共页数
                        if (prev_page_url === null) { // 上一页
                            $('.front-link').hide(); // 没有第一页
                        } else {
                            $('.front-link').attr('href', current + '?cate_id=' + cate_id + '&page=' + prev_page_url.split("?page=")[1])
                        }
                        if (next_page_url === null) { // 下一页
                            $('.after-link').hide(); // 没有最后一页
                        } else {
                            $('.after-link').attr('href', current + '?cate_id=' + cate_id + '&page=' + next_page_url.split("?page=")[1])
                        }
                    }
                } else {
                    $('.pager').css('opacity', '0');
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 最新、综合、活动跳转
    newsTabPage: function() {
        $('.news .tab-title').on('click', 'a', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?cate_id=' + cate_id + '&page=1'
        });
    },
    // 新闻详情
    newsInfo: function() {
        var id = obj.getQueryVariable('id');
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: "https://api.qingcigame.com/web/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                $('.news-det .main').addClass('main-show');
                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.article_excerpt; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    $('.news .news-title h3, .current-title').html(newsTitle);
                    $('.news .origin').html(origin);
                    $('.news .created_at').html(created_at);
                    $('.details-info').append(detailsInfo);

                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');

                    $('title').html(newsTitle);
                    $('meta[name="keywords"]').attr('content', json.data.list.article_keywords);
                    $('meta[name="description"]').attr('content', json.data.list.article_excerpt);
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 翻页功能
    pageDown: function(lastPage, nextPage, cite) {
        var href = window.location.href.split("?")[0] + '?' + cite + '='
        if (lastPage !== '') $('.prev-page').addClass('show').attr('href', href + lastPage.id).attr('title', lastPage.article_title);
        if (nextPage !== '') $('.next-page').addClass('show').attr('href', href + nextPage.id).attr('title', nextPage.article_title);
    },
    pageShow: function() {
        $('.page').addClass('pageShow');
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {
                if (json.code == 200) {
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        wx.config(json.data);
                        wx.ready(function() {
                            wx.updateAppMessageShareData({
                                title: '《新仙剑奇侠传之挥剑问情》手游（官方）', // 分享标题
                                desc: '新仙剑奇侠传全系列高清复刻，重现经典单机剧情，二十年前客栈中的少年情缘， 蜂引花笑，共蝶舞翩跹。二十年后重塑经典，高清渲染角色、场景，复刻我们记忆中的画面，再现青春回忆杀。新的故事，旧的回忆再度开启~', // 分享描述
                                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: 'https://download4.qcplay.com/qcgame-admin/wT7Seisy7rQw33fUDiFGBsg34JBCvGut2cg3cvMs.png', // 分享图标
                                success: function() {}
                            })

                            wx.updateTimelineShareData({
                                title: '《新仙剑奇侠传之挥剑问情》手游（官方）', // 分享标题
                                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: 'https://download4.qcplay.com/qcgame-admin/wT7Seisy7rQw33fUDiFGBsg34JBCvGut2cg3cvMs.png', // 分享图标
                                success: function() {
                                    // 设置成功
                                }
                            })
                        });
                        return;
                    } else {
                        try {
                            setShareInfo({
                                title: '《新仙剑奇侠传之挥剑问情》手游（官方）', // 分享标题
                                summary: '新仙剑奇侠传全系列高清复刻，重现经典单机剧情，二十年前客栈中的少年情缘， 蜂引花笑，共蝶舞翩跹。二十年后重塑经典，高清渲染角色、场景，复刻我们记忆中的画面，再现青春回忆杀。新的故事，旧的回忆再度开启~', // 分享内容
                                pic: 'https://download4.qcplay.com/qcgame-admin/wT7Seisy7rQw33fUDiFGBsg34JBCvGut2cg3cvMs.png', // 分享图片
                                url: window.location.href, // 分享链接
                                // 微信权限验证配置信息，若不在微信传播，可忽略
                                WXconfig: {
                                    swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                    appId: json.data.appId, // 公众号的唯一标识
                                    timestamp: json.data.timestamp, // 生成签名的时间戳
                                    nonceStr: json.data.nonceStr, // 生成签名的随机串
                                    signature: json.data.signature // 签名
                                }
                            });
                        } catch (err) {}
                    }
                }
            }
        })
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}